export default __webpack_public_path__ + "static/realestate_2-80eb210a070e0acd8b215bf6693c2145.webp";